import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { Roles } from 'src/app/shared/models/auth/role.model';
import { CostStatuses } from 'src/app/shared/models/cost.model';
import { CostActionsService } from 'src/app/shared/services/cost-actions.service';
import { of } from 'rxjs';
import {Advance, AdvanceType, AdvanceTypes} from '../../../shared/models/advance.model';


@Component({
  selector: 'app-cost-actions-top',
  templateUrl: './cost-actions-top.component.html',
})
export class CostActionsTopComponent implements OnInit, OnChanges {


  headerText: string;
  advancesTypes = AdvanceTypes;
  costStatuses = CostStatuses;
  @Input() costStatus: CostStatuses;
  @Input() costType;
  @Input() employeeId;
  @Input() advanceType: AdvanceTypes;
  @Input() roles: Roles[];
  @Input() canCurrentUserMakeAction: boolean;
  @Input() hasCreatedThisCost: boolean;
  @Input() approvalPathStepName;
  @Input() formattedDateCreatedAt;
  @Input() formattedDateUpdatedAt;
  @Input() costFormInvalid;
  @Output() actionEmitter = new EventEmitter();
  costOptions$;

  constructor(private costActionsService: CostActionsService) { }

  ngOnInit() {
  }

  ngOnChanges(change) {

    if (change['costStatus'] || change['approvalPathStepName']) {
      this.costOptions$ = of(
        this.costActionsService.getCostOptions(this.costStatus, this.roles, this.canCurrentUserMakeAction, this.hasCreatedThisCost)
      );
      this.determineHeaderText();
    }
  }

  determineHeaderText() {
    switch (this.costStatus) {
      case CostStatuses.New:
        this.headerText = 'W edycji';
        break;
      case CostStatuses.InMeritoricalApproval:
      case CostStatuses.InFormalApproval:
      case CostStatuses.InApproval:
        // TODO Temporary fix
        // this.headerText = this.approvalPathStepName;
        this.headerText = 'W akceptacji';
        break;
      case CostStatuses.Approved:
        this.headerText = 'Drukowanie';
        break;
      case CostStatuses.Printed:
        this.headerText = 'Eksport';
        break;
      case CostStatuses.Exported:
          this.headerText = 'W płatności';
          break;
      case CostStatuses.ReadyToReturn:
        this.headerText = 'Zwrot';
        break;
      case CostStatuses.Returned:
        this.headerText = 'Potwierdzenie zwrotu';
        break;
      case CostStatuses.Rejected:
        this.headerText = 'Koszt odrzucony';
        break;
      case CostStatuses.Settled:
        this.headerText = 'Zwrócono';
        break;
      case CostStatuses.Canceled:
        this.headerText = 'Anulowano';
        break;
    }
  }

  emitAction(action) {
    this.actionEmitter.emit(action);
  }
}
